import { oktaGet } from '../oktaRequestWrapper';
import { ApiRoutes } from '../apiRoutes';

export interface CompanyAchDetails {
    bankName: string;
    abaNumber: string;
    accountNumber: string;
}

export interface CompanyRemittanceMailingAddress {
    lines: string[];
}

export interface CompanyRemittanceDetails {
    email: string;
    mailingAddress: CompanyRemittanceMailingAddress | null;
}

export interface CompanyPaymentInstructions {
    ach: CompanyAchDetails;
    remittance: CompanyRemittanceDetails;
}

export interface CompanyResponse {
    companyId: number;
    name: string;
    paymentInstructions: CompanyPaymentInstructions;
}

export const getAvailableCompaniesAsync = async (): Promise<CompanyResponse[]> => {
    const requestConfig = {
        headers: {
         'api-version': '2.1',
        },
    };

    const response = await oktaGet<CompanyResponse[]>(ApiRoutes.Companies, requestConfig);
    return response.data;
}
